import { Modal, ModalContent, ModalHeader } from '@nextui-org/react';
import React from 'react';
import { Buttons } from '@/components';

const DeleteModal: React.FC<{
  isOpen: boolean;
  onOpenChange: () => void;
  onSubmit: () => void;
  loading: boolean;
}> = ({ isOpen, onOpenChange, onSubmit, loading }) => {

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      hideCloseButton
      scrollBehavior="inside"
      placement="center"
    >
      <ModalContent className="w-[400px] rounded-[20px]">
        {(onClose) => (
          <>
            <ModalHeader className="flex items-center justify-between p-6 pb-4">
              <span className="text-[18px] font-semibold">Delete API Key</span>
            </ModalHeader>
            <div className="px-6 pb-6">
              <p className="text-[14px] font-medium mb-1">Do you want to delete this key?</p>
              <div className="flex items-center justify-end mt-6 gap-3">
                <Buttons onClick={onClose} typeBtn="cancel">Cancel</Buttons>
                <Buttons isLoading={loading} onClick={onSubmit}>Delete</Buttons>
              </div>
            </div>
          </>
        )}
      </ModalContent>
    </Modal>
  )
}

export default DeleteModal;